import { Fragment, useState } from "react";
import CustomSelectDropdown from "../../../../components/CustomHTMLElements/CustomSelectDropdown";
import { useLockUnlockAdminUser } from "../../../../components/ManageRoles/hooks/useLockUnlockAdminUser";

const LOCK_REASONS = [
  "Suspicious activity",
  "Policy violation",
  "User request",
  "Security concern",
  "Other",
];

const UNLOCK_REASONS = [
  "Issue resolved",
  "Identity verified",
  "User request approved",
  "Administrative unlock",
  "Other",
];

export default function LockUnlockUserForm({ user, onBack, onSuccess }) {
  const isCurrentlyLocked = user?.isLocked;
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");

  const { mutate: lockUnlockMutate, result: lockUnlockResult } =
    useLockUnlockAdminUser();
  const isLoading = lockUnlockResult.isLoading;

  const reasons = isCurrentlyLocked ? UNLOCK_REASONS : LOCK_REASONS;
  const actionLabel = isCurrentlyLocked ? "Unlock" : "Lock";
  const isLockAction = !isCurrentlyLocked;

  const handleSubmit = (e) => {
    e.preventDefault();
    lockUnlockMutate(
      {
        ssoUserId: user?.sso_user_id,
        isLocked: !isCurrentlyLocked,
        reason,
        comment,
      },
      {
        onSuccess: () => {
          if (onSuccess) onSuccess();
        },
      },
    );
  };

  return (
    <Fragment>
      <h3 className="Modal__title p-b-2 text-center">{actionLabel} User</h3>

      <div
        className={`alert ${isLockAction ? "alert-warning" : "alert-info"} d-flex align-items-start mb-3`}
        role="alert"
      >
        <i
          className={`fas fa-${isLockAction ? "exclamation-triangle" : "info-circle"} mr-2 mt-1`}
        />
        <span>
          {isLockAction ? (
            <>
              You are about to <strong>lock</strong> this user. They will lose
              access to the platform until unlocked.
            </>
          ) : (
            <>
              You are about to <strong>unlock</strong> this user. They will
              regain full access to the platform.
            </>
          )}
        </span>
      </div>

      <div
        className="d-flex align-items-center p-3 mb-3 rounded"
        style={{ background: "#f8f9fa", border: "1px solid #e9ecef" }}
      >
        <i className="fas fa-user-circle fa-2x text-secondary mr-3" />
        <div>
          <div className="font-weight-bold">
            {user?.firstName} {user?.lastName}
          </div>
          <div className="text-muted" style={{ fontSize: "0.875rem" }}>
            {user?.email}
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="m-t-2 m-b-2">
          <CustomSelectDropdown
            name="reason"
            label={`${actionLabel} Reason`}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            iconType="fas fa-list"
            isShowDropdownArrow
          >
            <option value="">-- Select a reason --</option>
            {reasons.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </CustomSelectDropdown>
        </div>

        <div className="m-t-2 m-b-2">
          <label htmlFor="lockUnlockComment" className="label-txt">
            Comment{" "}
            <span className="text-muted font-weight-normal">(optional)</span>
          </label>
          <div className="form-group">
            <textarea
              id="lockUnlockComment"
              className="user__form form-control"
              rows={6}
              placeholder={`Add a comment for ${actionLabel.toLowerCase()}ing this user...`}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              style={{ resize: "vertical", minHeight: "120px" }}
            />
          </div>
        </div>

        <div className="Form__action-buttons m-t-1">
          <button
            type="button"
            className="btn advancly-white-btn m-0 mr-auto"
            onClick={onBack}
            disabled={isLoading}
          >
            <i className="fas fa-arrow-left"></i>
            &nbsp; Back
          </button>
          <button
            type="submit"
            className={`btn ${isLockAction ? "advancly-red-btn" : "advancly-btn"} m-0 ml-auto`}
            disabled={isLoading || !reason}
          >
            <i
              className={`fas fa-${isCurrentlyLocked ? "lock-open" : "lock"}`}
            ></i>
            &nbsp; {isLoading ? `${actionLabel}ing...` : `${actionLabel} User`}
          </button>
        </div>
      </form>
    </Fragment>
  );
}
